var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record)?_c('div',[(_vm.rsettings[0].settings.cposition)?_c('h2',[_vm._v(_vm._s(_vm.record.computations.student_position)+" "),_c('v-icon',[_vm._v("mdi-medal")]),_vm._v(" "),_vm._t("default")],2):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }